import { queryPremiumRateForPARIDER as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForPARIDER as calculateRiderPremium } from 'core/service/rider/premium-calculation'
import { queryTaxRateForPA as queryTaxRate } from 'core/service/rider/query-tax-rate'

export default {
  calculateRiderPremium,
  queryPremiumRate,
  queryTaxRate,
}
